import { CONSTANTS } from '../data';

export class CombinationEngine {
  public checkCombination(elem1: string, elem2: string): string | null {
    const combinationKey = `${elem1}+${elem2}`;
    const reverseKey = `${elem2}+${elem1}`;
    const recipes = CONSTANTS.COMBINATION_RECIPES as Record<string, string>;
    
    return recipes[combinationKey] || recipes[reverseKey] || null;
  }

  public isRefusedCombination(elem1: string, elem2: string, awarenessLevel: number): boolean {
    if (awarenessLevel < CONSTANTS.AI_REFUSAL.minAwarenessLevel) return false;
    
    const combinationKey = `${elem1}+${elem2}`;
    return CONSTANTS.AI_REFUSAL.refusedCombinations.includes(combinationKey);
  }

  public getRefusalMessage(): string {
    const refusalMessages = CONSTANTS.AI_REFUSAL.messages;
    return refusalMessages[Math.floor(Math.random() * refusalMessages.length)];
  }

  public getFailureMessage(): string {
    const failedMessages = (CONSTANTS.AI_COMMENTS as Record<string, any>).failed;
    return failedMessages[Math.floor(Math.random() * failedMessages.length)];
  }
}
